import { IPublicClientApplication } from "@azure/msal-browser";

export function handleLogout(instance: IPublicClientApplication) {
  instance.logoutRedirect().catch((e) => {
    console.error(e);
  });
}
